module.exports = __webpack_public_path__ + "static/media/white-polyline-measure-icon.2ae913c3.svg";